import { SustainabilityShortInfoSheetComponent } from './sustainability-short-info-sheet.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ SustainabilityComponent: SustainabilityShortInfoSheetComponent });
